import { useEffect, useState } from "react";
import MainLayout from "../components/layout/MainLayout";
import commonService from "../services/commonServices";
import CustomAccordion from "../components/CustomAccordion";

const FAQ = () => {
  const [faqList, setFaqList] = useState(null);
  const getFaqList = async () => {
    try {
      let response = await commonService.getFaqList();

      if (response.data.status) {
        let newArr = [];
        response?.data?.data?.forEach((val) => {
          newArr.push({ id: val?.id, title: val?.question, subTitle: val?.answer });
        });
        setFaqList(newArr);
      }
    } catch (error) {
      console.log("Error fetching faq list", error);
    }
  };
  useEffect(() => {
    getFaqList();
  }, []);
  return (
    <MainLayout>
      {" "}
      <h3 className="text-primary text-xl font-bold p-6">FAQs</h3>
      <section className="faqmodal container relative mx-auto h-[470px] overflow-auto">
        <CustomAccordion list={faqList} />
        {faqList?.length === 0 && (
          <div className="text-center justify-center items-center flex flex-col h-[440px] space-y-6">
            <img className="object-cover object-center relative" alt="" src={require("../assets/images/no-faq-data.webp")} />
            <span className="text-base text-black-900 font-medium my-2 xs:px-5 sm:px-20">It seems that no FAQs have been added yet.</span>
          </div>
        )}
      </section>
    </MainLayout>
  );
};

export default FAQ;
